/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultCompany } from '../../models/api-response-paged-result-company';
import { PagedRequestCompany } from '../../models/paged-request-company';

export interface SearchCompany$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestCompany
}

export function searchCompany(http: HttpClient, rootUrl: string, params: SearchCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultCompany>> {
  const rb = new RequestBuilder(rootUrl, searchCompany.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultCompany>;
    })
  );
}

searchCompany.PATH = '/v1/api/admin-ui/company/search';
